import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
    modal: "",
    header: _ctx.$t('global_components.sumup_checkout_widget_modal.view.title'),
    onShow: _ctx.initWidget,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed'))),
    class: "sumup_checkout_modal",
    maximizable: ""
  }, {
    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { id: "sumup-widget" }, null, -1)
    ]))]),
    _: 1
  }, 8, ["visible", "header", "onShow"]))
}